import styled from 'styled-components'

export const Options = styled.div`
  display: flex;
  flex-wrap: wrap;

  > div {
    margin: 0 30px 30px 0;

    &:last-child {
      margin-right: 0;
    }
  }
`
